import { Heading, HStack, Text, VStack } from '@chakra-ui/react';
import React, { FC, PropsWithChildren } from 'react';

import s from './PageTitle.module.scss';

interface Props extends PropsWithChildren {
  title: string;
  subtitle?: string;
}

export const PageTitle: FC<Props> = ({ title, subtitle, children }) => {
  return (
    <HStack
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <VStack alignItems="flex-start">
        <Heading as="h5" className={s.heading}>
          {title}
        </Heading>
        {subtitle && (
          <Text
            fontSize="16px"
            fontWeight="400"
            lineHeight="20px"
            color="whiteOpacity.50"
          >
            {subtitle}
          </Text>
        )}
      </VStack>
      {children}
    </HStack>
  );
};
